/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState } from "react";
import { Input, Button, Row, Col, Popover, Modal, Form, Select, message } from "antd";
import { SearchOutlined, MoreOutlined, LeftOutlined, RightOutlined, CustomerServiceOutlined, EditOutlined, DeleteOutlined, CloseOutlined, CheckCircleFilled, PlusOutlined } from "@ant-design/icons";
import supportContactIcon from "../../assests/images/SVG/contact-support.svg";
import copyIcon01 from "../../assests/images/SVG/copy-01.svg";
import pencilEditIcon from "../../assests/images/SVG/pencil-edit.svg";
import deleteExIcon from "../../assests/images/SVG/delete-ex.svg";
import successPopIcon from "../../assests/images/SVG/successpop.svg";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import "./style.scss";
import API from "../../api";
import urls from "../../api/urls";
import { useEffect } from "react";



const MenuContent = ({ onEdit, onDelete }) => (
    <div className="menu-options-popover">
        <div className="options-box">
            <div className="menu-item" onClick={onEdit}>
                <img src={pencilEditIcon} alt="edit" className="menu-svg-icon" />
                <span>Edit</span>
            </div>
            <div className="menu-divider" />
            <div className="menu-item" onClick={onDelete}>
                <img src={deleteExIcon} alt="delete" className="menu-svg-icon" />
                <span>Delete</span>
            </div>
        </div>
    </div>
);

const ContactCard = ({ contact, onEdit = () => { }, onDelete = () => { } }) => {
    const [popoverVisible, setPopoverVisible] = useState(false);

    const handleEdit = () => {
        setPopoverVisible(false);
        if (typeof onEdit === "function") {
            onEdit(contact);
        }
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(contact.phone || "")
            .then(() => {
                message.success("Contact number copied!");
            })
            .catch(err => {
                message.error("Failed to copy contact number");
                console.error("Failed to copy: ", err);
            });
    };

    const handleDelete = () => {
        setPopoverVisible(false);
        if (typeof onDelete === "function") {
            onDelete(contact);
        }
    };

    return (
        <div className="contact-card">
            <div className="contact-info">
                <span className="name">{contact.name}</span>
                <div className="phone-row">
                    <span>{contact.phone ? `+91 ${contact.phone}` : ""}</span>
                    <span className="copy-btn" onClick={handleCopy}><img src={copyIcon01} alt="copy" style={{ width: "18px", height: "18px" }} /></span>
                </div>
                <div className={`role-tag ${contact.tag}`}>
                    {contact.role}
                </div>
            </div>
            <Popover
                content={<MenuContent onEdit={handleEdit} onDelete={handleDelete} />}
                trigger="click"
                visible={popoverVisible}
                onVisibleChange={(visible) => setPopoverVisible(visible)}
                placement="bottomRight"
                overlayClassName="support-popover-overlay"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
                <MoreOutlined className="kebab-menu" />
            </Popover>
        </div>
    );
};





const SupportAndContactView = () => {
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
    const [editingContact, setEditingContact] = useState(null);
    const [successData, setSuccessData] = useState({ name: "", hub: "", role: "" });
    const [hubSearchValue, setHubSearchValue] = useState("");
    const [form] = Form.useForm();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0); // Total elements
    const [totalPages, setTotalPages] = useState(0); // Total pages from API
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(50);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = async (currentPage, currentSize, search) => {
        setLoading(true);
        try {
            const params = {
                page: currentPage,
                size: currentSize,
                pageNum: currentPage, // some APIs use pageNum
                pageSize: currentSize, // some APIs use pageSize
            };
            if (search) {
                params.search = search;
            }
            const res = await API.Api(urls.GET_ESCALATION_MATRIX).getwithParamsEx(params);
            if (res.status) {
                const content = res.response.data.content || [];
                // Group the flat records by Hub so we can show levels 1-5 in a single row
                const groupedData = content.reduce((acc, current) => {
                    const hubId = current.hubId;
                    if (!acc[hubId]) {
                        acc[hubId] = {
                            hubId: current.hubId,
                            hubName: current.hubName,
                            zone: current.zone,
                            levels: []
                        };
                    }
                    acc[hubId].levels.push(current);
                    return acc;
                }, {});
                setData(Object.values(groupedData));
                setTotal(res.response.data.totalElements || 0);
                setTotalPages(res.response.data.totalPages || 0);
            } else {
                message.error("Failed to fetch escalation matrix data");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            message.error("An error occurred while fetching data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page, size, searchTerm);
    }, [page, size, searchTerm]);

    const handleSearch = (value) => {
        setSearchTerm(value);
        setPage(0);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const getPaginationItems = () => {
        if (totalPages <= 0) return [];
        if (totalPages <= 6) return [...Array(totalPages)].map((_, i) => i + 1);

        const current = page + 1;
        const items = new Set([1, 2, 3, totalPages]);
        items.add(current);

        const sorted = Array.from(items).sort((a, b) => a - b);
        const result = [];
        let prev = 0;

        for (const p of sorted) {
            if (prev > 0 && p - prev > 1) {
                result.push("...");
            }
            result.push(p);
            prev = p;
        }
        return result;
    };

    const handleEditClick = (contact, hubName, levelIndex) => {
        setEditingContact({ ...contact, hubName, level: `Level ${levelIndex + 1}` });
        form.setFieldsValue({
            name: contact.name,
            phone: contact.phone,
            role: contact.role,
            hub: hubName,
            level: `Level ${levelIndex + 1}`
        });
        setIsEditModalVisible(true);
    };

    const handleAddClick = () => {
        setEditingContact(null);
        form.resetFields();
        setIsEditModalVisible(true);
    };

    const handleCancel = () => {
        setIsEditModalVisible(false);
        setEditingContact(null);
        setHubSearchValue("");
        form.resetFields();
    };

    const handleDeleteClick = async (contact) => {
        try {
            if (!contact || !contact.id) {
                message.error("Invalid contact ID");
                return;
            }
            const res = await API.Api(`${urls.GET_ESCALATION_MATRIX}/${contact.id}`).deleteIdHeader();
            if (res && res.response && res.response.status === 204) {
                message.success("Member delete successfully");
                fetchData(page, size, searchTerm);
            } else {
                message.error("Member not delete successfully");
            }
        } catch (error) {
            console.error("Error deleting member:", error);
            message.error("Member not delete successfully");
        }
    };

    const [hubList, setHubList] = useState([]);

    const fetchHubList = async () => {
        try {
            const res = await API.Api(urls.GET_HUB_LISTS).getWithHeader();
            if (res && res.status) {
                const data = res.response.data || [];
                // Check if data is array or wrapped
                let hubs = [];
                if (Array.isArray(data)) {
                    hubs = data;
                } else if (data.data && Array.isArray(data.data)) {
                    hubs = data.data;
                } else if (data.content && Array.isArray(data.content)) {
                    hubs = data.content;
                }

                // Map to desired format if needed, or just use as is
                // Assuming we need premiseName
                setHubList(hubs);
            }
        } catch (error) {
            console.error("Error fetching hub list:", error);
        }
    };

    useEffect(() => {
        fetchHubList();
    }, []);

    const onFinish = async (values) => {
        try {
            // Find hub ID from hubList based on selected name
            const selectedHub = hubList.find(h => (h.premiseName || h.hubName) === values.hub);
            const hubId = selectedHub ? (selectedHub.premiseId || selectedHub.hubId) : null;

            // Extract level number from string "Level X"
            const levelNum = parseInt(values.level.replace("Level ", ""), 10);

            const payload = {
                hubId: hubId,
                name: values.name,
                mobileNumber: values.phone,
                userRole: values.role,
                category: "Operations",
                level: levelNum
            };

            const res = await API.Api(urls.GET_ESCALATION_MATRIX).post(payload);

            if (res.status && res.response && res.response.status === 201) {
                setSuccessData({
                    name: values.name,
                    hub: values.hub,
                    role: values.role
                });
                setIsEditModalVisible(false);
                setIsSuccessModalVisible(true);
                // Refresh list
                fetchData(0, size, searchTerm);
            } else {
                message.error("Failed to add escalation member");
            }
        } catch (error) {
            console.error("Error adding member:", error);
            message.error("An error occurred details");
        }
    };

    const handleSuccessClose = () => {
        setIsSuccessModalVisible(false);
        setHubSearchValue("");
        form.resetFields();
    };




    return (
        <div className="support-contact-container">
            <div className="support-header">
                <div className="title-section">
                    <img src={supportContactIcon} alt="support-contact" className="support-icon-main" style={{ width: "21px", height: "21px" }} />
                    <h2>Support & Contact</h2>
                </div>
                <div className="search-section">
                    <Input
                        placeholder="Search Hubs, Zone or Name.."
                        prefix={<SearchOutlined />}
                        bordered={true}
                        onChange={(e) => handleSearch(e.target.value)}
                        allowClear
                        className="search-input"
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        className="add-member-btn"
                        onClick={handleAddClick}
                    >
                        Add Member
                    </Button>
                </div>
            </div>

            <div className="support-table-card">
                <div className="table-header-row">
                    <span>Hub - Zone</span>
                    <span>Level 1</span>
                    <span>Level 2</span>
                    <span>Level 3</span>
                    <span>Level 4</span>
                    <span>Level 5</span>
                </div>
                <div className="table-body">
                    {loading ? (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", flex: 1 }}>
                            <img src={Smcs_Loader} alt="loading" style={{ height: "100px", width: "100px" }} />
                        </div>
                    ) : data.length === 0 ? (
                        <div className="no-data-message">No escalation contacts found</div>
                    ) : (
                        data.map((row, index) => (
                            <div className="table-row" key={index}>
                                <div className="hub-name">{row.hubName} - {row.zone}</div>
                                {[1, 2, 3, 4, 5].map((levelNum) => {
                                    const contact = row.levels?.find(l => l.level === levelNum);
                                    return (
                                        <div className="level-cell" key={levelNum}>
                                            {contact ? (
                                                <ContactCard
                                                    contact={{
                                                        id: contact.id,
                                                        name: contact.name,
                                                        phone: contact.mobileNumber,
                                                        role: contact.userRole,
                                                        tag: contact.level % 2 === 0 ? "tag-blue" : "tag-green" // Adjust tag logic as needed
                                                    }}
                                                    onEdit={(c) => handleEditClick(c, row.hubName, levelNum - 1)}
                                                    onDelete={(c) => handleDeleteClick(c)}
                                                />
                                            ) : (
                                                <div className="empty-cell">-</div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ))
                    )}
                </div>
                <div className="pagination-container">
                    <Button
                        className="prev-btn"
                        icon={<LeftOutlined />}
                        disabled={page === 0}
                        onClick={() => handlePageChange(page - 1)}
                    >
                        Previous
                    </Button>
                    <div className="page-numbers">
                        {getPaginationItems().map((item, index) => (
                            <div
                                key={index}
                                className={`page-item ${item === page + 1 ? "active" : ""} ${item === "..." ? "dots" : ""}`}
                                onClick={() => item !== "..." && handlePageChange(item - 1)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                    <Button
                        className="next-btn"
                        disabled={page >= totalPages - 1 || totalPages === 0}
                        onClick={() => handlePageChange(page + 1)}
                    >
                        Next <RightOutlined />
                    </Button>
                </div>
            </div>




            <Modal
                title={(
                    <span
                        style={{
                            fontFamily: "Roboto",
                            fontSize: "18px",
                            fontWeight: "600",
                            lineHeight: "28px",
                            letterSpacing: "0%",
                            color: "#101828"
                        }}
                    >
                        Add New Escalation Member
                    </span>
                )}
                visible={isEditModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={712}
                centered={true}
                bodyStyle={{ padding: "12px 24px 24px 24px" }}
                className="manage-member-modal"
                closeIcon={(
                    <CloseOutlined
                        style={{
                            color: "#667085",
                            fontSize: "14px",
                            border: "1px solid #D1D5DB",
                            borderRadius: "50%",
                            padding: "4px"
                        }}
                    />
                )}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className="custom-form"
                >
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                label={(
                                    <span style={{ color: "#344054", fontStyle: "normal", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px", lineHeight: "20px", letterSpacing: "0%" }}>
                                        Name <span style={{ color: "#ff4d4f" }}>*</span>
                                    </span>
                                )}
                                name="name"
                                rules={[
                                    { required: true, message: "Please enter Full Name" },
                                    { pattern: /^[a-zA-Z\s]*$/, message: "Please enter only letters and spaces" }
                                ]}
                                getValueFromEvent={(e) => e.target.value.replace(/[^a-zA-Z\s]/g, "")}
                            >
                                <Input placeholder="Enter Full Name" style={{ height: "44px", borderRadius: "8px" }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={(
                                    <span style={{ color: "#344054", fontStyle: "normal", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px", lineHeight: "20px", letterSpacing: "0%" }}>
                                        Mobile Number <span style={{ color: "#ff4d4f" }}>*</span>
                                    </span>
                                )}
                                name="phone"
                                rules={[
                                    { required: true, message: "Please enter Mobile Number" },
                                    { pattern: /^[0-9]{10}$/, message: "Please enter a valid 10-digit mobile number" }
                                ]}
                            >
                                <Input placeholder="Enter Mobile Number" maxLength={10} style={{ height: "44px", borderRadius: "8px" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item
                                label={(
                                    <span style={{ color: "#344054", fontStyle: "normal", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px", lineHeight: "20px", letterSpacing: "0%" }}>
                                        Hub
                                    </span>
                                )}
                                name="hub"
                            >
                                <Select
                                    placeholder="Select Hub"
                                    showSearch
                                    optionFilterProp="children"
                                    searchValue={hubSearchValue}
                                    onSearch={(val) => setHubSearchValue(val.replace(/[^a-zA-Z\s]/g, ""))}
                                    onSelect={() => setHubSearchValue("")}
                                >
                                    {hubList.map((hub) => (
                                        <Select.Option key={hub.premiseId || hub.hubId} value={hub.premiseName || hub.hubName}>
                                            {hub.premiseName || hub.hubName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={(
                                    <span style={{ color: "#344054", fontStyle: "normal", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px", lineHeight: "20px", letterSpacing: "0%" }}>
                                        User Role
                                    </span>
                                )}
                                name="role"
                            >
                                <Select placeholder="Select user Role">
                                    <Select.Option value="Operation Executive">Operation Executive</Select.Option>
                                    <Select.Option value="Executive">Executive</Select.Option>
                                    <Select.Option value="Operations Manager">Operations Manager</Select.Option>
                                    <Select.Option value="Hub Incharge">Hub Incharge</Select.Option>
                                    <Select.Option value="Shift Supervisor">Shift Supervisor</Select.Option>
                                    <Select.Option value="Zonal Head">Zonal Head</Select.Option>
                                    <Select.Option value="Regional Manager">Regional Manager</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <Form.Item
                                label={(
                                    <span style={{ color: "#344054", fontStyle: "normal", fontFamily: "Roboto", fontWeight: "400", fontSize: "14px", lineHeight: "20px", letterSpacing: "0%" }}>
                                        Level <span style={{ color: "#ff4d4f" }}>*</span>
                                    </span>
                                )}
                                name="level"
                            >
                                <Select placeholder="Select Level">
                                    <Select.Option value="Level 1">Level 1</Select.Option>
                                    <Select.Option value="Level 2">Level 2</Select.Option>
                                    <Select.Option value="Level 3">Level 3</Select.Option>
                                    <Select.Option value="Level 4">Level 4</Select.Option>
                                    <Select.Option value="Level 5">Level 5</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <div
                        className="form-footer"
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "12px"
                        }}
                    >
                        <Button
                            className="cancel-btn"
                            onClick={handleCancel}
                            style={{
                                height: "40px",
                                borderRadius: "8px",
                                fontWeight: "600",
                                color: "#344054",
                                border: "1px solid #D0D5DD",
                                background: "#FFFFFF",
                                width: "112px"
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="add-btn"
                            type="primary"
                            htmlType="submit"
                            style={{
                                height: "40px",
                                borderRadius: "8px",
                                fontWeight: "600",
                                color: "#FFFFFF",
                                background: "#175CD3",
                                border: "none",
                                width: "112px"
                            }}
                        >
                            Add
                        </Button>
                    </div>
                </Form>
            </Modal>

            <Modal
                visible={isSuccessModalVisible}
                onCancel={handleSuccessClose}
                footer={null}
                width={400}
                centered={true}
                className="success-modal-custom"
                closable={false}
            >
                <div className="success-content">
                    <img src={successPopIcon} alt="success" className="success-pop-svg" />
                    <h3 className="success-title">New Member added Successfully</h3>
                    <p className="success-description">
                        <span className="name-highlight">{successData.name}</span> Has been added as the <span className="bold-text">New Member</span> for <span className="bold-text-blue">{successData.hub}</span> in Escalation Chain
                    </p>
                    <div className="success-footer">
                        <Button className="cancel-btn" onClick={handleSuccessClose}>
                            Cancel
                        </Button>
                        <Button className="done-btn" type="primary" onClick={handleSuccessClose}>
                            Done
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SupportAndContactView;
